import React, { useEffect, useState } from "react";

// Lightweight CSS confetti burst. Renders a fixed set of colourful pieces
// that fall & drift once, then the parent removes it.
const COLORS = ["#0d9488", "#06b6d4", "#fbbf24", "#fb7185", "#34d399", "#a78bfa", "#ffffff"];

export default function Confetti({ count = 90 }) {
  const [pieces, setPieces] = useState([]);

  useEffect(() => {
    const arr = Array.from({ length: count }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 0.5,
      dur: 2.2 + Math.random() * 1.8,
      size: 7 + Math.random() * 9,
      rot: Math.random() * 360,
      drift: (Math.random() - 0.5) * 220,
      color: COLORS[i % COLORS.length],
      round: Math.random() > 0.5,
    }));
    setPieces(arr);
  }, [count]);

  return (
    <div className="fixed inset-0 z-[90] pointer-events-none overflow-hidden" aria-hidden="true">
      {pieces.map((p) => (
        <span
          key={p.id}
          className="confetti-piece"
          style={{
            left: `${p.left}%`,
            width: p.size,
            height: p.size,
            background: p.color,
            borderRadius: p.round ? "50%" : "2px",
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.dur}s`,
            "--crot": `${p.rot}deg`,
            "--cdrift": `${p.drift}px`,
          }}
        />
      ))}
    </div>
  );
}
